import { render, staticRenderFns } from "./WarningProp.vue?vue&type=template&id=a8f33d42&"
import script from "./WarningProp.vue?vue&type=script&lang=js&"
export * from "./WarningProp.vue?vue&type=script&lang=js&"
import style0 from "./WarningProp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports